import Api from '../../../shared/Api';
import { IOrderRowMetadata } from '../Entities';

class PhotographerUploadsApi {
    static listPhotographerUpload(): any {
        return new Api().get('/views/photographer-uploads');
    }

    static saveMetaData(metadataList: IOrderRowMetadata[]): any {
        return new Api().post('/views/photographer-uploads/meta', {
            metadataList: metadataList
        });
    }

    static setImageInProgress(imageInfo: any, orderId: number): any {
        return new Api().post(
            `/views/photographer-uploads/in-progress/${orderId}`,
            { ...imageInfo },
            { numberOfRetries: 3, delay: 10000 }
        );
    }

    static sendWakeUpImageScaleFunction(): any {
        return new Api().post('/views/photographer-uploads/wake-up-image-scale-function', {});
    }
}

export default PhotographerUploadsApi;
